export const i18nContentHash = '5542eb0'
